import React from 'react';
import { Box, Link } from '@cko/primitives';
import styled from 'styled-components';
import { IconActionAbout } from '@cko/icons';
const IconAbout = styled(IconActionAbout) `
  vertical-align: text-bottom;
  path {
    fill: var(--action-bg-primary);
  }
`;
export const SearchHelp = ({ url }) => {
    return (React.createElement(Box, { borderTop: "var(--base-border-secondary)", p: "var(--layout-soybean) var(--layout-stamp)" },
        React.createElement(Link, { href: url, target: "blank" },
            React.createElement(IconAbout, null),
            " Help")));
};
